import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { WebStorageStateStore } from 'oidc-client-ts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { queryClient } from './constants';
import { AUTH_AUTHORITY } from './constants/auth';
import { RouterMap } from './core';
import { routerConfiguration } from './router';

import './index.css';
import './store';
import './translations';

const applicationUrl = new URL('/', window.location.origin).toString();

const oidcConfig: AuthProviderProps = {
  authority: AUTH_AUTHORITY,
  client_id: import.meta.env.VITE_APP_AUTH_CLIENT_ID,
  redirect_uri: applicationUrl,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <RouterMap routes={routerConfiguration} />
        </Router>
        <ToastContainer />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);
